module.exports = "<p>\n  faq works!\n</p>\n"